import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=1f8e2794&"
import script from "./BaseInput.vue?vue&type=script&lang=ts&"
export * from "./BaseInput.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports